module.exports = __webpack_public_path__ + "img/marble.80c6be37.jpg";